<template>
    <div>
        <BACK title="新增徵才/求職" name='Home'/>
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label="新增類別" prop="interviewType">
                <div class="clear">
                    <el-checkbox v-for="({interviewType, interviewName},idx) in jobType" v-model="interviewOption[idx]"
                                 :key="idx" @change="chengeJobType(idx)">{{interviewName}}
                    </el-checkbox>
                </div>
            </el-form-item>
            <el-form-item label="選擇地區" prop="areaId">
                <div class="clear">
                    <el-select class="select_area" popper-class="select_area_popper" v-model="form.areaId"
                               placeholder="請選擇">
                        <el-option v-for="({areaId, areaName},idx) in searchArea" :label="areaName" :value="areaId"
                                   :key="idx"/>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="薪水區間" prop="payFrom">
                <div class="flex">
                    <el-input v-model="form.payFrom" type="number" clearable placeholder="不限" oninput="if(value.length>5)value=value.slice(0,8)"></el-input>
                    <span class="text_pad color_primary">到</span>
                    <el-input v-model="form.payTo" type="number" clearable placeholder="不限" oninput="if(value.length>5)value=value.slice(0,8)"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="聯絡姓名" prop="contactName">
                <el-input v-model="form.contactName" type="text" maxlength="30" clearable
                          placeholder="請輸入聯絡人名稱"></el-input>
            </el-form-item>
            <el-form-item label="聯絡資訊" prop="contactMemo">
                <el-input v-model="form.contactMemo" type="text" maxlength="30" clearable
                          placeholder="請輸入聯絡資訊"></el-input>
            </el-form-item>
            <el-form-item label="標題" prop="title">
                <el-input v-model="form.title" type="text" maxlength="30" clearable placeholder="輸入標題"></el-input>
            </el-form-item>
            <el-form-item label="內容敘述" prop="content">
                <el-input v-model="form.content" maxlength="1000" type="textarea" :autosize="{ minRows: 5}"></el-input>
            </el-form-item>
        </el-form>
        <div class="note">*文章均遵守<span class="tag" @click="openTerms">《服務條款》</span></div>
        <div class="btn">
            <el-button type="success" :disabled="loading" @click="handleSubmit"><i class="el-icon-loading"
                                                                                   v-if="loading"></i>送出
            </el-button>
        </div>
        <DialogTerms :visbileName="'dialogTermsVisible'"/>
    </div>
</template>
<script>

    import BACK from '@/components/back.vue'
    import FN from '@/components/fn'
    import DialogTerms from '@/components/DialogTerms'
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: 'add',
        components: {
            BACK,
            DialogTerms
        },
        mixins: [FN],
        data() {
            return {
                interviewOption: {
                    0: false,
                    1: false
                },
                form: {
                    title: '',
                    areaId: 1,
                    payTo: '',
                    payFrom: '',
                    pay: '',
                    interviewType: '',
                    content: '',
                    contactName: '',
                    contactMemo: ''
                }
            }
        },
        computed: {
            ...mapGetters([
                'jobType',
                'searchArea'
            ]),
            rules() {
                const message = '輸入不完整'
                // 自訂驗證-interviewType
                const isinterviewType = (rule, value, callback) => {
                    if (!this.interviewOption[0] && !this.interviewOption[1]) {
                        callback(new Error('請選擇徵才類別'))
                    } else {
                        callback()
                    }
                }
                // 自訂驗證-Pay
                const isPay = (rule, value, callback) => {
                    if (this.form.payTo && +this.form.payTo < +this.form.payFrom) {
                        callback(new Error('最高月薪不可低於最低月資'))
                    } else {
                        callback()
                    }
                }
                return {
                    interviewType: [
                        {required: true, trigger: 'change', validator: isinterviewType}
                    ],
                    areaId: [{required: true, trigger: 'change', message}],
                    title: [{required: true, trigger: 'change', message: "請輸入標題"}],
                    content: [{required: true, trigger: 'change', message: '請輸入內容敘述'}],
                    payFrom: this.form.payFrom === '' && this.form.payTo === '' ? [] : [
                        {required: true, trigger: 'change', validator: isPay}
                    ],
                    contactName: [{required: true, trigger: 'change', message: '請輸入聯絡姓名'}],
                    contactMemo: [{required: true, trigger: 'change', message: '請輸入聯絡資訊'}]
                }
            }
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            chengeJobType(idx) {
                if (this.interviewOption[idx]) {
                    this.interviewOption[Math.abs(idx - 1)] = false
                    this.form.interviewType = +this.jobType[idx].interviewType
                }
            },
            beforeFormSubmit() {
            },
            //送出表單
            handleSubmit() {
                //清除進階搜尋資料
                const form = this.$refs.form
                this.beforeValidate()
                this.clearSearchData()
                form.validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.beforeFormSubmit()
                        this.FETCH({
                            key: 'JOB_ADD',
                            ...this.form
                        }).then((res) => {
                            //需要accToken的驗證
                            if (+(res || {}).code === -3) {
                                this.checkNewToken(this.handleSubmit)
                            } else {
                                this.handleResponse(res)
                            }
                        })
                    } else {
                        this.loading = false
                        this.handleUnValid()
                    }


                })

            },
            //回應
            handleResponse(res) {
                if (!+res.code) {
                    this.$confirm('恭喜您獲得1次抽獎機會!!',{
                        title:"文章已新增",
                        confirmButtonText: '前往抽獎',
                        cancelButtonText: '回列表',
                        type: 'success',
                        closeOnClickModal: false
                    }).then(() => {
                        this.$router.replace({name: 'Lottery'})
                    }).catch(() => {
                        this.$router.replace({name: 'Job', params: {tag: 'my'}})
                        this.$parent.handleSearch()
                    });
                } else {
                    this.$confirm(res.message, {
                        showCancelButton: false,
                        type: 'error'
                    })
                }
                this.loading = false
            },
            getDetail() {
                const id = this.$route.params.id
                this.FETCH({
                    key: 'JOB_DETAIL',
                    id: id
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getDetail)
                    }
                })
            },
            handleBack() {
                this.$router.replace({name: 'Job'})
            },
            //清除搜尋資料
            clearSearchData() {
                this.$parent.qkArea = ''
                this.$parent.form.areaId = []
                this.$parent.form.payTo = ''
                this.$parent.form.payFrom = ''
                this.$parent.form.orderByPay = ''
                this.$parent.form.interviewType = ''
            }, getMemberInfo() {
                this.FETCH({
                    key: 'USER_INFO',
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.handleSubmit)
                    } else {
                        if (!+res.code) {
                            this.form.contactName = res.data.nickname;
                            this.form.contactMemo = '電話-'+res.data.phone;
                        }
                    }
                })
            }
        }, mounted() {
            this.getMemberInfo()
        }
    }
</script>
